export enum IdentityProvider {
  Okta = 'wppoktaprod',
  GroupM = 'groupm-ad',
  MagicLink = 'magic-link',
  IBM = 'ibm-open',
}
